var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c;
import localforage from "localforage";
import { getDeviceId, getToken, handleStatusGaCalls, setToken } from "../../../helpers";
import { triggerTveBeaconEvents } from "../../../OnBoarding-V2/LoginV2/Views/TveLoginFLow/helper";
import request from "graphql-request";
import Cookies from 'js-cookie';
import pubsub from "@viewlift/pubsub";
import { updateAuthorisationStore } from "../../../MFEs/web-authentication-sdk/src/updateStore";
import { publishAppLoading } from "../../../OnBoarding-V2/Events/utils.events";
import jwtDecode from "jwt-decode";
var apiBaseUrl = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsMain) === null || _b === void 0 ? void 0 : _b.apiConfig) === null || _c === void 0 ? void 0 : _c.apiBaseUrl;
var tveProvider = window.app_data.appcmsPlatform.tveSettings.tveProvider;
var query = "mutation ($site: String!, $input: SignInTveInput!) {\n    identitySignInTve(site: $site, input: $input) {\n      userId\n      tveUserId\n      provider\n      providers\n      idpName\n      idpLogo\n      planId\n      authorizationToken\n      refreshToken\n    }\n  }";
export var registerTveUser = function (_a) {
    var _b = _a.tveUserId, tveUserId = _b === void 0 ? null : _b, mvpd = _a.mvpd, _c = _a.zip, zip = _c === void 0 ? null : _c, _d = _a.encryptedZip, encryptedZip = _d === void 0 ? null : _d, _e = _a.path, path = _e === void 0 ? '/' : _e, resourceIds = _a.resourceIds, setIsLoading = _a.setIsLoading;
    if (window.cancel) {
        return;
    }
    window.cancel = true;
    var generateId = function (_) {
        var s4 = function (_) { return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1); };
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    };
    var deviceId = getDeviceId();
    var endpoint = "".concat(apiBaseUrl, "/graphql");
    localforage.getItem('AuthenticationStore').then(function (AuthenticationStore) {
        var _a, _b;
        var user = AuthenticationStore === null || AuthenticationStore === void 0 ? void 0 : AuthenticationStore.user;
        var tveAccesToken = Cookies.get('TveAccessToken');
        var getFingerprintDeviceId = localStorage.getItem('fingerprintDeviceId');
        var getAnonymousToken = Cookies.get('token') && JSON.parse(Cookies.get('token'));
        var decodeToken = jwtDecode(getAnonymousToken === null || getAnonymousToken === void 0 ? void 0 : getAnonymousToken.authorizationToken);
        var anoynomousUserId = decodeToken.userId;
        var variables = {
            'site': ((_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.site) === null || _b === void 0 ? void 0 : _b.siteInternalName) || null,
            "input": {
                "mvpdProvider": mvpd,
                "provider": mvpd,
                "userId": (user === null || user === void 0 ? void 0 : user.userId) || anoynomousUserId,
                "idpName": mvpd,
                "email": (user === null || user === void 0 ? void 0 : user.email) || '',
                "platform": "web_browser",
                "device": "web_browser",
                "deviceName": "WEB",
                "deviceId": deviceId,
                "channelIds": resourceIds,
                "tveUserId": tveUserId || (user === null || user === void 0 ? void 0 : user.userId),
                "adbAccessToken": tveAccesToken || "",
                "adbDeviceId": "fingerprint ".concat(getFingerprintDeviceId) || ""
            },
        };
        // if(tveUserId !== null || tveUserId !== undefined){
        //   variables.input.tveUserId = tveUserId
        // }
        if (zip !== null || zip !== undefined) {
            variables.input["adobeMetadata"] = {
                zip: zip
            };
        }
        if (encryptedZip !== null || encryptedZip !== undefined) {
            variables.input["adobeMetadata"] = __assign(__assign({}, variables.input["adobeMetadata"]), { encryptedZip: encryptedZip });
        }
        getToken(function (token) {
            var contentApiHeaders = {
                'x-api-key': window === null || window === void 0 ? void 0 : window.xApiKey,
                authorization: token
            };
            triggerTveBeaconEvents('TVE_LOGIN_SUCCESS');
            triggerTveBeaconEvents('TVE_VL_LOGIN_INIT');
            handleStatusGaCalls({ eventName: 'tve_vl_login_init', subSection: null, type: 'tve', reason: mvpd, status: null, additionalLabel: null, action: 'VL Login Init', paymentStatus: null, eventCategory: 'Authentication', section: 'checkout' });
            request(endpoint, query, variables, contentApiHeaders).then(function (res) {
                var _a, _b, _c, _d, _e, _f;
                window.cancel = false;
                var checkoutInitPageData = sessionStorage.getItem('checkoutInitPageData');
                var checkoutInitPageDetails = JSON.parse(checkoutInitPageData);
                var entitlementToken = localStorage.getItem('entitlementToken');
                var user = JSON.parse(entitlementToken);
                var mvpd = (user === null || user === void 0 ? void 0 : user.mvpd) || null;
                var tveSuccessEventData = {
                    "pageUrl": checkoutInitPageDetails === null || checkoutInitPageDetails === void 0 ? void 0 : checkoutInitPageDetails.pageUrl,
                    "mvpdProvider": mvpd,
                    "tveProvider": (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsPlatform) === null || _b === void 0 ? void 0 : _b.tveSettings) === null || _c === void 0 ? void 0 : _c.tveProvider
                };
                triggerTveBeaconEvents('TVE_VL_LOGIN_SUCCESS');
                handleStatusGaCalls({ eventName: 'tve_vl_login_success', subSection: null, type: 'tve', reason: tveSuccessEventData === null || tveSuccessEventData === void 0 ? void 0 : tveSuccessEventData.mvpdProvider, status: null, additionalLabel: null, action: 'VL Login Success', paymentStatus: null, eventCategory: 'Authentication', section: 'checkout' });
                var d = (res === null || res === void 0 ? void 0 : res.identitySignInTve) && {
                    authorizationToken: (_d = res === null || res === void 0 ? void 0 : res.identitySignInTve) === null || _d === void 0 ? void 0 : _d.authorizationToken,
                    refreshToken: (_e = res === null || res === void 0 ? void 0 : res.identitySignInTve) === null || _e === void 0 ? void 0 : _e.refreshToken
                };
                setToken(d);
                updateAuthorisationStore({ userdetails: __assign(__assign(__assign({}, res === null || res === void 0 ? void 0 : res.identitySignInTve), user), { authorizationToken: (_f = res === null || res === void 0 ? void 0 : res.identitySignInTve) === null || _f === void 0 ? void 0 : _f.authorizationToken }) })
                    .then(function () {
                    var _a;
                    window.location.href = "".concat((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.origin).concat(window.location.pathname);
                });
            })
                .catch(function (err) {
                var _a, _b, _c;
                console.log(err);
                triggerTveBeaconEvents('TVE_VL_LOGIN_FAILURE');
                handleStatusGaCalls({ eventName: 'tve_vl_login_failure', subSection: null, type: 'tve', reason: (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsPlatform) === null || _b === void 0 ? void 0 : _b.tveSettings) === null || _c === void 0 ? void 0 : _c.tveProvider, status: null, additionalLabel: null, action: 'VL Login Failure', paymentStatus: null, eventCategory: 'Authentication', section: 'checkout' });
                window.cancel = false;
                publishAppLoading(false);
                pubsub.publish('update-error-message', "error while connecting to TVE");
            });
        });
    });
};
